import { useQuery, DocumentNode } from '@apollo/client';

function useBlogPostsQuery(tags: string, BLOG_POST_QUERY: DocumentNode) {
  const { data, error, loading } = useQuery(BLOG_POST_QUERY, {
    variables: { tags },
  });

  return { loading, error, posts: data?.blogPosts };
}

export default useBlogPostsQuery;
